module.exports = __webpack_public_path__ + "static/media/landing-footer-mobile-image.69ff839a.webp";